// @owners { team: patients-team }
import { Column, Description, InlineAlert, MdSpacing } from '@alto/design-system';
import React from 'react';
import { PROGYNY_BILLING_DISCLAIMER } from '~shared/constants';

type Props = {
  readonly hasItemsBilledToProgyny: boolean;
};

export const ProgynyBillingNotice = ({ hasItemsBilledToProgyny }: Props) => {
  if (!hasItemsBilledToProgyny) return null;

  return (
    // flexShrink={0} so the InlineAlert isn't compressed/clipped inside a constrained flex column.
    <Column flexShrink={0}>
      <InlineAlert type="warning">
        <Description fontFamily="bold">{PROGYNY_BILLING_DISCLAIMER.TITLE}</Description>
        <Description>{PROGYNY_BILLING_DISCLAIMER.BODY}</Description>
      </InlineAlert>
      <MdSpacing />
    </Column>
  );
};
